import requestAction from '../../utils/requestAction'
import { ComplaintInput } from '../../models/Complaint';

export const upsertComplaint = (complaint: (ComplaintInput), handleResponse?: (messageId: number) => void) =>
  requestAction('COMPLAINT_UPSERT')(
    `complaints${(complaint as ComplaintInput).id ? `/${(complaint as ComplaintInput).id}` : ''}`,
    (complaint as ComplaintInput).id ? 'PUT' : 'POST',
    complaint,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.complaintId) })
